
<div :id="dropzoneId" ref='dropzone' :class="{'dropzone-single': !uploadMultiple}" class="dropzone"
     enctype="multipart/form-data" method="post">
  <div v-if="isOnlyButton" class="dz-default dz-message">
    <button :class="allButtonClasses" :disabled="disabled" data-type>
      <span :class="iconClass"></span>
      {{button.text}}
    </button>
  </div>
  <div v-else class="dz-default dz-message">
    <button v-if="!disabled || readonly" :disabled="readonly" type="button" :aria-required="required" :aria-describedby="ariaDescribedby">
      <icon :class="isImageUpload ? 'image-upload' : 'upload'"></icon>
      <span class="text-block">
        <span>{{dropFileText}}</span>
        <template v-if="allowsMultipleFiles">
          <span><small>Individual File size limit is {{individualMaxFileSize}} MB</small></span>
          <span><small>Total File size limit is {{totalMaxFileSize}} MB</small></span>
        </template>
        <template v-else-if="allowImageMinMax">
          <template v-if="imageWidthMax && imageHeightMax">
            <span><small>Max image resolution {{imageWidthMax}}px x {{imageHeightMax}}px</small></span>
          </template>
          <template v-if="imageWidthMin && imageHeightMin">
            <span><small>Min image resolution {{imageWidthMin}}px x {{imageHeightMin}}px</small></span>
          </template>
        </template>
        <template v-else>
          <span><small>File size limit is {{dropzoneOptions.maxFilesize}} MB</small></span>
        </template>
        <span v-if="isFileTypeRestricted"><small>{{fileRestrictionFriendlyText}}</small></span>
        <span :class="allButtonClasses">Choose {{isImageUpload ? 'image' : 'file'}}</span>
      </span>
    </button>
    <div v-else class="col py-2 d-flex justify-content-center align-items-center">
      <div class="icon blocked mr-3 align-self-center"></div>
      <label class="p-sm font-weight-normal text-left mb-0">Cannot upload or delete files</label>
    </div>
  </div>
</div>
